<template>
  <div style="position: relative;">
    <slot :questions="questions"></slot>
  </div>
</template>

<script>
import questions from '@views/question-editor/utils/questions'
import options from '@views/question-editor/utils/options'

export default {
  components: {},
  provide () {
    return {
      SjQuestion: this,
    }
  },
  props: {
    model: Array,
    scroll: [String, HTMLElement],
    fixedIds: {
      type: Array,
      default: () => []
    },
  },
  data () {
    return {}
  },
  computed: {
    questions () {
      return this.model
    },
    scrollEl () {
      if (this.scroll.constructor === String) {
        return document.querySelector(this.scroll)
      }
      return this.scroll
    },
  },
  watch: {},
  created () {},
  mounted () {},
  destroyed () {},
  methods: {
    /**
     * 添加题目
     *
     * @param data
     * @param type
     * @param toIndex
     */
    add (data, type, toIndex) {
      let question = questions.make(type)
      if (question.options) {
        question.options.push(options.make(type))
        question.options.push(options.make(type))
      }
      // 不能添加到固定题目之后
      if (data.length && this.fixedIds.includes(data[data.length - 1].id)) {
        toIndex = data.length - 1
      }
      // 复制到指定位置
      !Number.isInteger(toIndex) && (toIndex = data.length)
      questions.insert(data, question, toIndex)
    },
  },
  filters: {},
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/question-editor/packages/sj-question/src/SjQuestion.vue